import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';

export const ChipWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: ${spacings.SMALL};
`;
